import { createTheme } from '@mui/material/styles';
import { aeTheme } from '@ae/ui';

const theme = createTheme(aeTheme, {
  palette: {
    // AEDrive domain-specific extensions
    field: {
      grassLight: '#4a7c4e',
      grassDark: '#5a8c5e',
      white: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0.1)',
      line: 'rgba(255, 255, 255, 0.25)',
      goalArea: 'rgba(255, 255, 255, 0.1)',
    },
    player: {
      circle: '#2c2c2c',
      border: '#FEEB66',
      number: '#FFFFFF',
      label: '#FFFFFF',
    },
  },
  formation: {
    player: {
      circleRadius: 14,
      circleBorderWidth: 2,
      numberSize: 11,
      labelSize: 7,
      labelSpacing: '0.3px',
      fontWeight: 700,
    },
    field: {
      padding: 15,
      stripeCount: 8,
      goalAreaWidth: 0.35,
      goalAreaHeight: 20,
      goalAreaInnerWidth: 0.45,
      penaltyAreaWidth: 0.7,
      penaltyAreaHeight: 40,
      centerCircleRadius: 0.15,
      centerDotRadius: 2,
      lineWidth: 1,
      borderWidth: 2,
      borderRadius: 4,
    },
  },
  components: {
    // Don't restore focus to a dialog's trigger button on close (MUI's
    // default) — otherwise a later stray Enter re-fires that button's click.
    MuiDialog: {
      defaultProps: {
        disableRestoreFocus: true,
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        // Keep Firefox thin scrollbar; let WebKit/Safari use native overlay scrollbars
        body: {
          scrollbarColor: '#5b5b5b rgba(48, 44, 44, 0.85)', // thumb, track (Firefox)
          scrollbarWidth: 'thin',
        },
      },
    },
    // Global field styling for outlined inputs/selects
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(254, 235, 102, 0.7)', // default border
            borderWidth: 1,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4EC2F5', // focused / open
            borderWidth: 2,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(254, 235, 102, 0.9)',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(252, 252, 251, 0.7)',
          '&.Mui-focused': {
            color: '#4EC2F5',
          },
        },
      },
    },
    // Local mirror of the @ae/ui MuiAlert fix. The feed-pinned @ae/ui (^1.9.1)
    // gives standardInfo / standardWarning no text colour, so the
    // "Lineup updating from Aether…" info toast rendered black-on-dark and was
    // unreadable. Deep-merges over aeTheme's MuiAlert (border/bg/icon kept).
    // Remove once the app picks up @ae/ui ≥ 1.10.0, which carries this fix.
    MuiAlert: {
      styleOverrides: {
        standardInfo: { color: '#E0D9FF' },
        standardWarning: { color: '#FCE0B8' },
      },
    },
  },
});

export default theme;
